import { render, staticRenderFns } from "./create-edit-scenario.vue?vue&type=template&id=4b448546"
import script from "./create-edit-scenario.vue?vue&type=script&lang=js"
export * from "./create-edit-scenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports